import { TimeTableActions } from 'src/store/actions/timeTableActions';
const initialState = {
    timeTable: null,
    loading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case TimeTableActions.GET_TIME_TABLE_REQUEST: {
            return ({
                ...state,
                loading: true
            });
        }
        case TimeTableActions.GET_TIME_TABLE_SUCCESS: {
            return ({
                ...state,
                loading: false,
                timeTable: payload || null
            });
        }
        case TimeTableActions.GET_TIME_TABLE_FAIL: {
            return ({
                ...state,
                loading: false
            });
        }
        default: return state;
    }
};
